﻿import { OpaccDirectSearchSuggest } from './opacc.class.directsearchsuggest.js';

export const opaccDirectSearchSuggestPlugin = new OpaccDirectSearchSuggest();